<template>
  <fragment>
    <div v-show="page.state == 'rendered'" v-bind:style="{ transform: `rotate(${totalRotation}deg)` }">
      <canvas :width="page.width" :height="page.height" class="pdf-page box-shadow" ref="pdfCanvas">dibuix</canvas>
      <div id="text-layer" ref="textLayer"
        v-bind:style="{ top: textTop + 'px', height: defaultHeight + 'px', width: defaultWidth + 'px' }"
        class="moveforeground">
        <fragment v-if="permission.can_write">
          <PDFTextTag v-for="i in numTags" v-bind:key="i"
            v-bind="{ annotation: taggedText[pageNumber - 1][i - 1], index: i - 1, totalHeight: defaultHeight, totalWidth: defaultWidth }">
          </PDFTextTag>
        </fragment>
      </div>
    </div>
  </fragment>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import PDFTextTag from '../PDFTextTag'
import { Fragment } from 'vue-fragment'

export default {
  components: { PDFTextTag, Fragment },

  props: {
    page: {
      type: Object, // instance containing an instance of  PDFPageProxy returned from pdf.getPage
      required: true,
    },
  },
  data() {
    return {
      renderTask: undefined,
      isPageFocused: true,

      textLeft: 0,
      textTop: 10,
      textHeight: 1040,
      textWidth: 735,
    }
  },
  methods: {
    async drawPage() {
      if (this.page.state === 'downloaded') {
        const numPage = this.page.numPage
        const pdfPage = await this.getPDFPage(numPage)
        this.setPageValues({
          pageIndex: numPage,
          values: { state: 'rendering' }
        })
        const canvasContext = this.$refs.pdfCanvas.getContext("2d");
        const renderContext = { canvasContext, viewport: pdfPage.getViewport({ scale: 1. }) };
        const pdf_canvas = this.$refs.pdfCanvas;
        if (pdf_canvas) {
          this.textLeft = pdf_canvas.offsetLeft;
          this.textTop = pdf_canvas.offsetTop;
        }
        // PDFPageProxy#render
        // https://mozilla.github.io/pdf.js/api/draft/PDFPageProxy.html
        this.renderTask = pdfPage.render(renderContext);
        await this.renderTask.promise;
        if (this.page.state == 'rendering') {
          this.setPageValues({
            pageIndex: numPage,
            values: { state: 'rendered' }
          })
        } else {
          console.log('finished the render of a destroyed page')
        }
      }
    },
    rotate(deg) {
      this.doRotate({ page: this.pageNumber, rotation: deg })
    },
    ...mapActions({
      setPageValues: "pdf_data/setPageValues",
      getPDFPage: "pdf_data/getPDFPage",
      cleanPage: "pdf_data/cleanPage",
      doRotate: 'documents/doRotate',
    })
  },
  watch:{
    page(newPage,oldPage){
      this.cleanPage(oldPage.numPage)
    },
  },
  computed: {
    ...mapState("pdf_data", ["defaultWidth", "defaultHeight"]),
    ...mapGetters({
      userData: 'me/userData',
      taggedText: "documents/taggedText",
      zoom: "documents/zoom",
      inRotationMode: "documents/inRotationMode",
      rotationMode: "documents/rotationMode",
      globalRotation: "documents/globalRotation",
      rotationPerDocument: "documents/rotationPerDocument",
      permission: 'permissions/permission',
    }),
    counterZoom() {
      return 1 / this.zoom
    },
    totalRotation() {
      return this.globalRotation + (this.rotationPerDocument[this.pageNumber] || 0)
    },
    showRotation() {
      return this.inRotationMode && this.rotationMode === 'page'
    },
    shouldRender() {
      return ["downloaded", "rendering", "rendered"].includes(this.page.state);
    },
    pageNumber() {
      return this.page.numPage;
    },
    numTags() {
      let result = 0
      try {
        if (this.taggedText.length) {
          result = this.taggedText[this.pageNumber - 1].length
        }
      }
      catch (e) { }
      return result
    },
  },
  mounted() {
    this.drawPage()
  },
  updated() {
    this.drawPage()
  },
  beforeDestroy() {
    this.cleanPage(this.page.numPage)
  },
}
</script>

<style scoped>
.moveforeground {
  z-index: 10;
}

#text-layer {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  opacity: 0.9;
  line-height: 1;
  margin: 0 auto;
}

#text-layer>span {
  color: transparent;
  position: absolute;
  white-space: pre;
  cursor: text;
  transform-origin: 0% 0%;
}

.pdf-page {
  display: block;
  margin: 0 auto;
  background-color: #ffffff;
}
</style>

<style scoped>
::selection,
::-moz-selection {
  background: #cab7ff; /* WebKit/Blink Browsers/Gecko Browsers */
  color: transparent;
}
</style>